import React from 'react';

import {
  HStack,
  Heading,
  NewButton,
  Paragraph,
  Text,
  VStack,
} from '@eluve/components';

const FEATURES = [
  'Record as many appointments as you want',
  'Customize your note template',
  'Sync notes to your EHR',
  '30-day free trial — no credit card required',
];

interface WelcomeScreenProps {
  onContinue: () => void;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onContinue }) => {
  return (
    <VStack gap={6} className="p-8">
      <Heading size="2xl" weight="bold" color="primary">
        Welcome to Eluve!
      </Heading>
      <VStack gap={3}>
        <Paragraph size="md" className="text-left">
          Eluve is your AI medical scribe, here to automate your notes and help
          you get your time back.
        </Paragraph>
        {FEATURES.map((feature, index) => (
          <HStack key={index} wFull>
            <Text
              size="lg"
              color="primary"
              className="size-5 rounded-full font-bold leading-5"
            >
              ✓
            </Text>
            <Text size="md" color="primary" className="text-left">
              {feature}
            </Text>
          </HStack>
        ))}
      </VStack>

      <NewButton
        type="primary"
        size="m"
        text="Start using Eluve"
        wFull
        onClick={onContinue}
      />
    </VStack>
  );
};
